import useTracking from "hooks/useTracking"

const useTrackBodyLinks = () => {
  const { track } = useTracking()

  const extractNodeMetadata = (node) => {
    const eventData = {
      props: {
        page_type: "Article",
      },
    }

    // Extract data-track-prop attributes from node
    for (let i = 0; i < node.attributes.length; i += 1) {
      if (
        node.attributes[i].name.startsWith("data-track-prop-") &&
        node.attributes[i].value !== "" &&
        node.attributes[i].value !== null
      ) {
        eventData.props[node.attributes[i].name.slice(16).replace(/-/g, "_")] = node.attributes[
          i
        ].value.replace(/-/g, "_")
      }
    }

    // See if label contains values that should be replaced with other values
    if (eventData.props.label) {
      if (eventData.props.label.indexOf("|") > -1) {
        eventData.props.label = eventData.props.label
          .split("|")
          .map((item) => eventData.props[item.trim()] || item)
          .join("|")
      } else {
        eventData.props.label =
          eventData.props[eventData.props.label.trim()] || eventData.props.label
      }

      // Remove spaces before and after pipes in event label to ensure consistency
      eventData.props.label = eventData.props.label.replace(/\s?\|\s?/, "|")
    }

    // Get track event types from node, store in array
    const eventTypes = node.getAttribute("data-track-event-types").split(" ")
    const trackEventType = node.getAttribute("data-track-type")

    // create different impression types based on event types
    if (eventTypes && eventTypes.length && eventData.props) {
      eventTypes.forEach((eventType) => {
        switch (eventType) {
          case "render":
            if (trackEventType === "native-ad") {
              eventData.eventName = "Site Ad Rendered"
            } else {
              eventData.eventName = "Element Rendered"
            }
            break
          case "click":
            if (trackEventType === "native-ad") {
              eventData.eventName = "Site Ad Clicked"
            } else if (trackEventType === "article-link") {
              eventData.eventName = "Article Link Clicked"
            } else {
              eventData.eventName = "Element Clicked"
            }
            break
          default:
            break
        }
      })
    }

    return eventData
  }

  return (node) => {
    if (node.classList.contains("mbg-track-event")) {
      const metadata = extractNodeMetadata(node)
      track(metadata.eventName, metadata.props)
    }
  }
}

export default useTrackBodyLinks
